


/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {IconEnum, SizeEnum} from "@/ts/Enum";
import Media from "@/ts/Media";
import Materials from "@/ts/Materials";
import {MessageBase} from "@/ts/Announcement";
import ClassRoomService from "@/services/classRoom.service";

@Component({
  // components: {LwPdf},
})
export default class LessonsData extends Vue {
  @Prop({
    type: String,
    default: () => {
      return SizeEnum.small.toString()
    }
  }) 
  size
  @Prop() gardenId: string
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
    required: true,
  })
  materials: [];

  srcList = [];
  pic = IconEnum.pic;
  audio = new Media(false);
  video = new Media(false);
  pdfVisible = false;
  pdfUrl = "";

  mounted(): void {
  }

  // wordDetail() {
  //     // 微软提供的方法
  //     window.open('https://view.officeapps.live.com/op/view.aspx?src=' + this.materials[3].path)
  // }

  showDownload(icon) {
    // icon == IconEnum.pdf ||
    // ||icon == IconEnum.txt
    if (
        icon == IconEnum.pic ||
        icon == IconEnum.video ||
        icon == IconEnum.audio
    ) {
      return false;
    }
    return true;
  }

  srccc(icon: string) {
    if (icon) {
      return require(`@/assets/file-icon/${icon}`); //"@/assets/images/camera.png"
    }
    return null;
  }

  /**
   * 预览图片处理函数
   *
   * 将当前点击的图片放在预览的第一个，从当前图片开始向后预览
   * @param item
   */
  imagePreviewClickHandle(item: Materials) {
    // 如果可以预览的图片集合中没有当前图片，则不做后续处理
    const index = this.srcList.findIndex(e => item.path === e)
    if (index === -1) {
      return
    }
    // 先将从当前图片开始（包含当前图片）以及向后的所有图片截取复制到临时的集合中
    let nextImgList = this.srcList.slice(index, this.srcList.length)
    // 再将当前图片之前的图片（不包含当前图片）都添加到临时数组中
    let prevImgList =this.srcList.slice(0,index)
    // 将前后两个集合组合到一起返回给可预览图片数组，绑定到预览组件中
    this.srcList = nextImgList.concat(prevImgList)
  }

  open(item: Materials): void {
    const icon: string = item.icon;
    // console.log('open:' + icon);
    if (icon == IconEnum.pic) {
      //    打开图片预览
      // document.body
    } else if (icon == IconEnum.video) {
      ClassRoomService.getStreamMediaPlayUrl({
        gardenId: this.gardenId,
        filename: item.path
      }).then(res => {
        this.video.open();
        this.video.filePath = res.pcPlayUrl;
        this.video.title = item.name;
        console.log(this.video)
      })

    } else if (icon == IconEnum.audio) {
      this.audio.open();
      this.audio.filePath = item.path;
      this.audio.title = item.name;
    } else {
      item.download();
    }
    // else if (icon == IconEnum.pdf || icon == IconEnum.txt) {
    //     //||  icon == IconEnum.word ||
    //     //   icon == IconEnum.excel
    //     if (item.path) {
    //         // this.pdfVisible = true;
    //         // this.pdfUrl = item.path;
    //         // item.path="http://lw-oss-develop.oss-cn-beijing.aliyuncs.com/rtc_chat_image/20211101140935211144266914453423%20(2).pdf"
    //         const link = document.createElement("a");
    //         document.body.appendChild(link);
    //         // link.style.display = 'none'
    //         // 获取文件名
    //         link.setAttribute("title", item.name);
    //         link.href = item.path;
    //         link.target = "_new";
    //
    //         link.click();
    //         document.body.removeChild(link);
    //         // window.open(
    //         //   "https://view.officeapps.live.com/op/view.aspx?src=" + item.path
    //         // );
    //     }
    // }
  }

  close(type) {
    if (type === "audio") {
      this.audio.close();
    } else if (type === "video") {
      this.video.close();
    }
  }

  @Watch("materials", {immediate: true, deep: true})
  materialsWatch(nv, ov) {
    if (nv) {
      let filter = nv.filter((n) => n.icon == IconEnum.pic);
      if (filter) {
        this.srcList = filter.map((n) => n.path);
      }
    } else {
      this.srcList = [];
    }
  }
}
